import { useEffect, useRef } from 'react';

const useDebounce = (callback, delay, dependencies) => {
  const callbackRef = useRef(callback);
  const timeoutRef = useRef();

  // Update the callback, if it changes.
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const debouncedFn = (...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => callbackRef.current(...args), delay);
  };

  // Clear timeout when the component is unmounted or dependencies change.
  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, dependencies);

  return debouncedFn;
};

export default useDebounce;
